import { LancerActionTracker } from "@thilke/ui/components/lancer-action-tracker";
import { LancerCounter } from "@thilke/ui/components/lancer-counter";
import { LancerMechPanel } from "@thilke/ui/components/lancer-mech-panel";
import { LancerResourceBar } from "@thilke/ui/components/lancer-resource-bar";
import { LancerStatCard } from "@thilke/ui/components/lancer-stat-card";
import { LancerStructureStress } from "@thilke/ui/components/lancer-structure-stress";
import { useState } from "react";

export function LancerCounterDemo() {
  return (
    <div className="grid w-full max-w-md gap-4">
      <LancerCounter label="Structure" value={2} max={4} tone="default" />
      <LancerCounter label="Stress" value={1} max={4} tone="warning" />
      <LancerCounter label="Repairs" value={2} max={4} tone="info" size="sm" />
      <LancerCounter
        label="Burn"
        value={3}
        max={6}
        tone="destructive"
        size="sm"
      />
    </div>
  );
}

export function LancerResourceBarDemo() {
  return (
    <div className="grid w-full max-w-md gap-4">
      <LancerResourceBar label="HP" value={14} max={20} tone="destructive" />
      <LancerResourceBar label="Heat" value={6} max={12} tone="warning" />
    </div>
  );
}

export function LancerStatCardDemo() {
  return (
    <div className="grid w-full max-w-md grid-cols-3 gap-2">
      <LancerStatCard label="Evasion" value={10} />
      <LancerStatCard label="Armor" value={2} tone="accent" />
      <LancerStatCard label="E-Def" value={8} />
      <LancerStatCard label="Speed" value={5} tone="info" />
      <LancerStatCard label="Save" value={12} />
      <LancerStatCard label="Sensor" value={10} tone="muted" />
    </div>
  );
}

export function LancerActionTrackerDemo() {
  const [actions, setActions] = useState([
    { id: "protocol", label: "Protocol", active: false },
    { id: "movement", label: "Movement", active: true },
    { id: "full", label: "Full Action", active: false },
    { id: "quick", label: "Quick Action", active: true, count: 1 },
    { id: "reaction", label: "Reaction", active: false },
  ]);

  return (
    <LancerActionTracker
      actions={actions}
      onToggle={(id) =>
        setActions((prev) =>
          prev.map((action) =>
            action.id === id ? { ...action, active: !action.active } : action,
          ),
        )
      }
    />
  );
}

export function LancerStructureStressDemo() {
  const [structure, setStructure] = useState(2);
  const [stress, setStress] = useState(1);

  return (
    <div className="grid w-full max-w-md gap-3 sm:grid-cols-2">
      <LancerStructureStress
        type="structure"
        current={structure}
        max={4}
        onPipClick={setStructure}
      />
      <LancerStructureStress
        type="stress"
        current={stress}
        max={4}
        onPipClick={setStress}
      />
    </div>
  );
}

export function LancerMechPanelDemo() {
  const [actions, setActions] = useState([
    { id: "protocol", label: "Protocol", active: false },
    { id: "movement", label: "Movement", active: true },
    { id: "full", label: "Full", active: false },
    { id: "quick", label: "Quick", active: true, count: 1 },
    { id: "reaction", label: "Reaction", active: false },
  ]);
  const [structure, setStructure] = useState(2);
  const [stress, setStress] = useState(1);

  return (
    <div className="w-full max-w-lg">
      <LancerMechPanel
        name="GMS Everest"
        system="GMS"
        hp={{ id: "hp", label: "HP", value: 14, max: 20 }}
        heat={{ id: "heat", label: "Heat", value: 6, max: 12 }}
        structure={{
          id: "structure",
          label: "Structure",
          value: structure,
          max: 4,
        }}
        stress={{ id: "stress", label: "Stress", value: stress, max: 4 }}
        repairs={{ value: 2, max: 4 }}
        burn={{ value: 1, max: 6 }}
        stats={[
          { id: "evasion", label: "Evasion", value: 10 },
          { id: "armor", label: "Armor", value: 2, tone: "accent" },
          { id: "edef", label: "E-Def", value: 8 },
          { id: "speed", label: "Speed", value: 5, tone: "info" },
          { id: "save", label: "Save", value: 12 },
          { id: "sensor", label: "Sensor", value: 10 },
        ]}
        actions={actions}
        onActionToggle={(id) =>
          setActions((prev) =>
            prev.map((action) =>
              action.id === id ? { ...action, active: !action.active } : action,
            ),
          )
        }
        onStructurePipClick={setStructure}
        onStressPipClick={setStress}
      />
    </div>
  );
}
